import React, { useEffect, useRef, useState, useMemo } from "react";
import manageColumnImg from "./../../img/icons/manage-column-icon.svg";
import quickFilterImg from "./../../img/icons/filter-transparent-icon.svg";
import Button from "../Button";
import ResetTable from "../Table2/ResetTable";
import ShowSelected from "../ShowSelected";
import { useDispatch, useSelector } from "react-redux";
import { hashToSelectedValues } from "../../utilities/hash";
import { AddMyAnalogModalIcon } from "../AddToMyAnalogIcon/AddToMyAnalogIcon";
import localization from '../../data/config';
import * as EVENTS from "../../constants/config/dtm";
import { toggleParameters } from "../../actions/tools";
import ExcelDownload from "../ExcelDownload";
import { track } from "../../actions/dtm";
import SortBy from "../SortBy";
import Share from "../Share";
import "./style.css";

const { ofLabel } = localization;

const ManageTools = (props) => {
	const  dispatch = useDispatch();
	const manageContRef = useRef();
	const { allParameters, parameters: selectedParameters, quickFilter: jsonData } = useSelector((state) => state.filters );
	const { selected } = useSelector((state) => state.parts);
	const tableName = useSelector((state) => state.app.title);
	const showFilters = useMemo(() => Object.keys(jsonData).length > 0, [ jsonData ]);
	const [resetVisible, setResetVisible] = useState(false);
	const classNames = useMemo(() => {
		const ary = [ 'managecontainer' ];
		return ary.join( ' ' );
	}, [ ]);
	const showAllParameters = useMemo(() => {
		return allParameters && allParameters.length;
	}, [ allParameters ]);
	const showSelected = useMemo(() => {
		const selectedRows = hashToSelectedValues();
		const length = selected ? selected.length : 0
		return length > 0 || selectedRows.length > 0;
	}, [ selected ]);
	
	const handleToggle = () => {
		dispatch(toggleParameters());
		dispatch(track(EVENTS.CLOSE_PARAMETERS));
	};
	
	/**
	 * @name handleScrollTop
	 * @function
	 * @description Function that scrolls the user to the Quick Filter section when the button is clicked
	 */
	const handleScrollTop = () => {
		if(document.getElementById("pst-feature")){
			document.getElementById("pst-feature").scrollIntoView({behavior: "smooth"});
		}
	}

	useEffect(() => {
		if (window.location.hash && (window.location.hash).length > 2) {
			setResetVisible(true);
		} else {
			setResetVisible(false);
		}
	}, [window.location.hash]);

  	return (
		<div
			ref={ manageContRef }
			className={ classNames }
		>
      		
			<div className="manageparameters">
				<div className="filter-tools">
					<Button
						className="primary_btn"
						onClick={handleToggle}
						updateItemsCount={props.updateItemsCount}
					>
						<img src={manageColumnImg} alt="Manage Column Icon" className="filter-tools-img" />
						{ localization.manageToolsButton }
						{
							showAllParameters
								? (
									<span className="update__parameters__count">
										{ `${selectedParameters.length} ${ofLabel} ${ allParameters.length }` }
									</span>
								)
								: null
						}
					</Button>
					{ 
						showFilters 
							? (
								<div className="sticky_accordion">
									<Button
										className="secondary_btn sticky_button-quick-filter"
										onClick={handleScrollTop}
										updateItemsCount={props.updateItemsCount}
									>
										<img src={quickFilterImg} alt="Manage Column Icon" className="filter-tools-img" />
										<span>Quick Filter</span>
									</Button>
								</div>
							)
							: null
					}
					{
						showSelected 
							? (
								<ShowSelected />
							)
							: null
					}
					<SortBy options={localization.options}/>
					{
						resetVisible 
						? (
							<ResetTable />
						)
						: null
					} 
				</div>
				<div className="external-tools">
					<AddMyAnalogModalIcon tableName={tableName} role="button" aria-label={`${localization.resetTable}. ${localization.opensModal}`}/>     
					<ExcelDownload/>
					<Share/>
				</div>
			</div>
		</div>
  	);
};

export default ManageTools;